export default __webpack_public_path__ + "static/media/LowStock.f152f235.svg";